import { render, staticRenderFns } from "./ActivarIntegracionDialog.vue?vue&type=template&id=2c504339&"
import script from "./ActivarIntegracionDialog.vue?vue&type=script&lang=js&"
export * from "./ActivarIntegracionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c504339', component.options)
    } else {
      api.reload('2c504339', component.options)
    }
    module.hot.accept("./ActivarIntegracionDialog.vue?vue&type=template&id=2c504339&", function () {
      api.rerender('2c504339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ActivarIntegracion/ActivarIntegracionDialog.vue"
export default component.exports